import script from "./DashboardClientBonds.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardClientBonds.vue?vue&type=script&setup=true&lang=js"

import "./DashboardClientBonds.vue?vue&type=style&index=0&id=7aac747e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aac747e"]])

export default __exports__